import {
  getCategories,
  Input,
  MultiSearchForm,
  SwitchInput,
  useDebouncedSearch,
  useEffect,
  useRef,
  useState,
} from "@";
import { searchValues } from "../utils/options";

const MultiSearch = ({ onSubmit, search, updateSearch, dataLength }) => {
  const [categories, setCategories] = useState([]);
  const hasFetchedData = useRef(false);

  // Function to fetch categories
  const fetchCategories = async () => {
    const { data } = await getCategories();
    const options = data?.map((option) => ({
      value: option.id,
      label: option.name,
    }));
    setCategories(options);
  };

  useDebouncedSearch(onSubmit, search.values, searchValues);

  useEffect(() => {
    if (dataLength > 0 && !hasFetchedData.current) {
      fetchCategories();
      hasFetchedData.current = true;
    }
  }, [dataLength]);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      reset={() => updateSearch({ values: searchValues })}
      className="multi-search-form xl:grid-cols-4"
    >
      {/* Input for project title */}
      <Input
        change={(e) => handleInputChange("projectTitle", e.target.value)}
        value={search.values.projectTitle}
        label="عنوان المشروع"
        star
      />

      {/* Dropdown for selecting categories */}
      <Input
        star
        label="التصنيفات"
        type="select-searchable"
        value={categories?.filter(
          (c) => search.values.classificationId == c.value,
        )}
        list={categories}
        change={(e) =>
          handleInputChange("classificationId", e ? e.value : null)
        }
      />

      {/* Number range input */}
      <Input
        star
        type="number-range"
        labelA="المبلغ من"
        labelB="المبلغ الي"
        valueA={search.values.fromAmount}
        valueB={search.values.toAmount}
        changeA={(e) => handleInputChange("fromAmount", e.target.value)}
        changeB={(e) => handleInputChange("toAmount", e.target.value)}
      />

      <SwitchInput
        label="يوجد دفع حديث"
        checked={search.values.isRecentPaymentExists}
        change={(value) => handleInputChange("isRecentPaymentExists", value)}
      />

      {/* Datepicker input */}
      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="xl:col-span-2"
        valueB={search.values.toDate}
        valueA={search.values.fromDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
